module.exports = __webpack_public_path__ + "ondemand/static/8b50f6e88/media/background-image-favourites-2x3.jpg";